import { z } from 'zod';

export enum FiltersValueKey {
    searchQuery = 'searchQuery',
    ownerTypes = 'ownerTypes',
    ageing = 'ageing',
}

export const filtersSchema = z.object({
    [FiltersValueKey.searchQuery]: z.string(),
    [FiltersValueKey.ownerTypes]: z.array(z.string()).optional(),
    [FiltersValueKey.ageing]: z.array(z.string()).optional(),
});

export type CityLedgerFilterValues = z.infer<typeof filtersSchema>;
